module.exports = __webpack_public_path__ + "img/guest.a44bc07d.png";